import { BaseRestRepository } from '~/repositories/baseRestRepository';
import type {
  CreatePolicyHandbookDto,
  PolicyHandbookDto,
  PolicyHandbookPaginationDto,
  UpdatePolicyHandbookDto,
} from '~/swagger/portal/Api';

const baseUrl = '/api/policy-handbooks';

export class PolicyHandbookRepository extends BaseRestRepository {
  public async getPolicyHandbooks(): Promise<PolicyHandbookPaginationDto> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async createPolicyHandbook(payload: CreatePolicyHandbookDto): Promise<PolicyHandbookDto> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async updatePolicyHandbook(id: string, payload: UpdatePolicyHandbookDto): Promise<PolicyHandbookDto> {
    const url = `${baseUrl}/${id}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deletePolicyHandbook(id: string): Promise<void> {
    const url = `${baseUrl}/${id}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }
}
